import { message } from "antd";
import { DocumentTemplateFormCard } from "./components/DocumentTemplateForm";
import { useMutation } from "@tanstack/react-query";
import { DocumentTemplate } from "@rumble-it/common-lib/types/models/DocumentTemplate.interface";
import { useNavigate } from "react-router-dom";
import { createDocumentTemplate } from "@/lib/api/resources/documentTemplate";

export const DocumentTemplateCreate = () => {
  const navigate = useNavigate();

  const createDocumentTemplateMutation = useMutation({
    mutationFn: (data: DocumentTemplate) => createDocumentTemplate(data),
    onSuccess: () => {
      navigate("/document-templates");
      message.success("Document template succesvol aangemaakt");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het toevoegen van de document template",
      ),
  });

  return (
    <DocumentTemplateFormCard
      mutation={createDocumentTemplateMutation}
      initialValues={{ language: "nl" }}
    />
  );
};
